import React from "react";
import "./HierarchySelect.css";
import HierarchyDropdown from "../../../../../Components/UiComponents/HierarchyDropdown/HierarchyDropdown";
import { useTranslation } from "react-i18next";
import "react-dropdown-tree-select/dist/styles.css";
import { Controller } from "react-hook-form";
import HierarchyDropdownForRole from "../../../../../Components/UiComponents/HierarchyDropdown/HireForRole";
// In HierarchySelectForRole.js:
// In HierarchySelectForRole.js:

const HierarchySelectForRole = ({
  name,
  label,
  register,
  errors,
  options,
  control,
  mandatory,
  onChange,
  disabled = false,
  mobileAccess,
  getValues,
  treeKey,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <label style={{ color: disabled ? "#6c759d" : "" }}>
        {t(label)}
        {mandatory && <span className="asterisk">*</span>}
      </label>
      <Controller
        control={control}
        name={name}
        render={({ field: { value, onChange: fieldOnChange } }) => (
          <HierarchyDropdownForRole
            // This key is crucial - when it changes, the component unmounts and remounts
            key={`hierarchy-dropdown-${treeKey}`}
            data={options || null}
            className={
              errors[name] ? "form-select form__select--errorborder" : ""
            }
            value={value}
            onChange={(currentNode, selectedNodes) => {
              fieldOnChange(selectedNodes);
              if (onChange) {
                onChange(currentNode, selectedNodes);
              }
            }}
            id={name}
            disabled={disabled}
            mobileAccess={mobileAccess}
          />
        )}
      />
      <div className="error__message">{errors[name]?.message}</div>
    </div>
  );
};

export default HierarchySelectForRole;